import {mapGetters} from 'vuex'

// Custom mixin, con Vue.mixin no se puede acceder a this correctamente
export default {
  data() {
    return {
      map: undefined,
      zoom: 13,
      position: {
        lat: 0,
        lng: 0
      }
    }
  },

  computed: {
    ...mapGetters(['mapEngine', 'googleMapsApiKey', 'osmUrl', 'osmAttribution']),

    noBusStyle() {
      return [{featureType: 'transit.station.bus', stylers: [{visibility: 'off'}]}]
    }
  },

  created() {
    if (this.$municipality) this.position = this.$municipality.geo

    window.addEventListener('orientationchange', () => {
      // Recalcular el mapa
      setTimeout(() => { this.map.invalidateSize() }, 500)
    })
  },

  methods: {
    /*
     * Almacena el mapa para usarlo posteriormente
     */
    storeMap(event) {
      this.map = event.target
    },

    /*
     * Centra el mapa en las coordenadas especificadas
     */
    centerMap(position) {
      if (this.map) {
        this.position = position
        this.map.setView(position, 14)
      }
    },

    /**
     * Cierra los popups del mapa
     */
    closePopups() {
      if (this.map) this.map.closePopup()
    }
  }
}
